<template>
    <App title="Station Discount Management">
        <div class="station-discount-page">
            <!-- Header Section -->
            <div class="page-header mb-4">
                <div class="d-flex justify-content-between align-items-center">
                    <div>
                        <h4 class="fw-semibold mb-1">Station Discount Management</h4>
                        <p class="text-muted small mb-0">Update battery swap discounts record for stations</p>
                    </div>
                   
                </div>
            </div>

            <!-- Edit Discount Form -->
            <transition name="fade">
                <div class="mb-4">
                    <div class="card border-0 shadow-sm">
                        <div class="card-header bg-white border-0 py-3 d-flex justify-content-between align-items-center">
                            <h6 class="mb-0 fw-semibold">Edit Discount</h6>
                            <button 
                                type="button" 
                                class="btn-close" 
                                @click="closeEditForm"
                                aria-label="Close"
                            ></button>
                        </div>
                        <div class="card-body">
                            <DiscountForm
                                :url="route('discount.ajax.update',{discount:discount.id})"
                                :pricing-url="route('price.ajax.lookup')"
                                :battery-types="orderTypes"
                                :discount-data="discount"
                                :update-form="true"
                                @success="handleUpdateSuccess"
                                @error="handleDiscountError"
                                @cancel="handleCancel"
                               
                            />
                        </div>
                    </div>
                </div>
            </transition>

           
        </div>
    </App>
</template>

<script lang="ts">
import { Component, Prop, Vue, toNative } from 'vue-facing-decorator'
import DiscountForm from '@/vue/components/DiscountForm.vue'
import App from '@/vue/templates/App.vue'
import Datatable from '@/vue/components/Datatable.vue'
import { CellRender, Column } from '@/vue/utils/Datatable'
import Swal from 'sweetalert2'

interface Station {
    value: string
    name: string
}

interface OrderType {
    value: string
    name: string
}

interface DiscountData {
    id: number
    price: {
        id: number
        station: {
            id: string
            title: string
        }
        type: string
        amount: number
    }
    amount: number
    orders: number
    activated_at: string
}

@Component({
    components: {
        DiscountForm,
        App,
        Datatable
    }
})
class Discount extends Vue {

    @Prop({ type: Array, default: () => [] })
    readonly orderTypes!: OrderType[]
    @Prop({ type: Object })
	readonly discount!: DiscountData


    showAddForm = false
    showEditForm = false
    selectedDiscount: DiscountData | null = null

    handleDiscountSuccess(event: any) {
        this.showToast(event.message, 'success')
        this.showAddForm = false
     
    }

    handleUpdateSuccess(event: any) {
        this.showToast(event.message, 'success')
        this.router.visit(this.route('discount.page.group'))
     
    }

    handleDiscountError(event: any) {
        this.showToast(event.message, 'error')
    }

    handleCancel() {
        this.router.visit(this.route('discount.page.group'))
        
    }

 

    

    showToast(message: string, type: 'success' | 'error') {
        Swal.fire({
            toast: true,
            position: 'top-end',
            icon: type,
            title: message,
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            didOpen: (toast) => {
                toast.addEventListener('mouseenter', Swal.stopTimer)
                toast.addEventListener('mouseleave', Swal.resumeTimer)
            }
        })
    }


    formatDate(date: string): string {
		return new Date(date).toLocaleDateString('en-NG', {
			year: 'numeric',
			month: 'short',
			day: 'numeric'
		})
	}

 
}

export default toNative(Discount)
</script>

<style scoped>
.station-discount-page {
    padding: 1.5rem;
    max-width: 1400px;
    margin: 0 auto;
}

.page-header h4 {
    color: #212529;
    font-size: 1.5rem;
}

.discount-card {
    transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.discount-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.1) !important;
}

.badge {
    font-weight: 500;
    padding: 0.35rem 0.65rem;
}

.bg-light {
    background-color: #f8f9fa !important;
}

.bg-success {
    background-color: #198754 !important;
    color: white !important;
}

.bg-warning {
    background-color: #ffc107 !important;
    color: #212529 !important;
}

.text-success {
    color: #0f5132 !important;
}

.text-muted {
    color: #6c757d !important;
}

/* Transitions */
.fade-enter-active, .fade-leave-active {
    transition: opacity 0.3s ease;
}

.fade-enter-from, .fade-leave-to {
    opacity: 0;
}

.slide-down-enter-active, .slide-down-leave-active {
    transition: all 0.3s ease;
    max-height: 100px;
    overflow: hidden;
}

.slide-down-enter-from, .slide-down-leave-to {
    max-height: 0;
    opacity: 0;
}

/* Responsive */
@media (max-width: 768px) {
    .station-discount-page {
        padding: 1rem;
    }

    .page-header h4 {
        font-size: 1.25rem;
    }
}
</style>